import React from "react";
import { Search, Filter } from "lucide-react";

interface ImpressionJobFiltersProps {
  campaignFilter: string;
  statusFilter: "" | "processing" | "completed" | "failed";
  cityFilter: string;
  onCampaignFilterChange: (value: string) => void;
  onStatusFilterChange: (value: "" | "processing" | "completed" | "failed") => void;
  onCityFilterChange: (value: string) => void;
}

export const ImpressionJobFilters: React.FC<ImpressionJobFiltersProps> = ({
  campaignFilter,
  statusFilter,
  cityFilter,
  onCampaignFilterChange,
  onStatusFilterChange,
  onCityFilterChange,
}) => {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <div className="flex items-center gap-2 mb-4">
        <Filter className="w-5 h-5 text-gray-500" />
        <h2 className="text-lg font-medium text-gray-900">Filters</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Campaign Filter */}
        <div>
          <label htmlFor="campaign-filter" className="block text-sm font-medium text-gray-700 mb-1">
            Campaign ID
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              id="campaign-filter"
              value={campaignFilter}
              onChange={(e) => onCampaignFilterChange(e.target.value)}
              placeholder="Search campaign..."
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            />
          </div>
        </div>

        {/* Status Filter */}
        <div>
          <label htmlFor="status-filter" className="block text-sm font-medium text-gray-700 mb-1">
            Status
          </label>
          <select
            id="status-filter"
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value as "" | "processing" | "completed" | "failed")}
            className="block w-full px-3 py-2 border border-gray-300 rounded-md bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="">All Statuses</option>
            <option value="processing">Processing</option>
            <option value="completed">Completed</option>
            <option value="failed">Failed</option>
          </select>
        </div>

        {/* City Filter */}
        <div>
          <label htmlFor="city-filter" className="block text-sm font-medium text-gray-700 mb-1">
            City
          </label>
          <input
            type="text"
            id="city-filter"
            value={cityFilter}
            onChange={(e) => onCityFilterChange(e.target.value)}
            placeholder="Filter by city..."
            className="block w-full px-3 py-2 border border-gray-300 rounded-md leading-5 bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
        </div>
      </div>
    </div>
  );
};
